module.exports = __webpack_public_path__ + "af569aa09253b1ac78382f71c8b3f181.svg";